import React from 'react'
import useStateRef from 'react-usestateref'

const SearchedAdjustment = ({ containerObject, templateName, contentId, dataZone }) => {
   const [searchedvalue, setSearchedvalue, searchedvalueRef] = useStateRef(containerObject.searchedValue ? containerObject.searchedValue : "")
	 const [searchedSpellCheckValue, setSearchedSpellCheckValue, searchedSpellCheckValueRef] = useStateRef(containerObject.searchedSpellCheckValue ? containerObject.searchedSpellCheckValue : "")
  return (
    <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row g-0`} >
        <div className='row g-0 searched-adjustment px-2'>
        {!searchedvalueRef.current && !searchedSpellCheckValueRef.current ? "" : searchedvalueRef.current && !searchedSpellCheckValueRef.current ? <h1 className="right-panel-heading searched-adjustment-heading">{`You searched for "${searchedvalueRef.current}"`}</h1> : <h1 className="right-panel-heading">{`You searched for "${searchedvalueRef.current}" and we corrected that to "${searchedSpellCheckValueRef.current}"`}</h1>}
       
        </div>
    </div>
  )
}

export default SearchedAdjustment